import { render } from "./receipt.vue?vue&type=template&id=6d0b444a&scoped=true"
import script from "./receipt.vue?vue&type=script&lang=js"
export * from "./receipt.vue?vue&type=script&lang=js"

import "./receipt.vue?vue&type=style&index=0&id=6d0b444a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0b444a"]])

export default __exports__